import { PapelAssistente } from './assistente.interface'

export function papelDoUsuario (kind?: string, perfilAtual?: string): PapelAssistente {
  if (kind === 'mine' || perfilAtual === 'pessoal') return 'empregado'
  if (kind === 'group') return 'gestor'
  return 'rh'
}
